import React from 'react';
import { ArrayHelpers, Forms, Help, Loading, Modal, SystemText } from '@salesperformanceint/e4shared';
import { apiGet } from 'services';
import Wizard from 'views/user/appraisals/components/wizard';

export const Preview = ({ show, close, roles, user }) => {
    const st = (path, ...rest) => SystemText(`Admin/Roles/Preview/${path}`, ...rest);

    const [selected, setSelected] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [preview, setPreview] = React.useState({ participants: 'UM' });
    const [stage, setStage] = React.useState(-1);
    const [inReview, setInReview] = React.useState(false);

    React.useEffect(() => {
        if (ArrayHelpers.existsAndHasLength(selected)) {
            setStage(-1);
            setLoading(true);
            apiGet(`role-review-preview?roles=${selected.toString()}`, user.guid, response => {
                setLoading(false);
                setPreview(response);
            });
        }
    }, [selected]);

    return (
        <Modal title={st('Title')} show={show} close={close} footer={null}>
            <div>
                <Forms.Select
                    data-testid="select-roles"
                    label={st('Roles/Label')}
                    data={roles.filter(r => !selected.some(x => x === r.id))}
                    onChange={x => setSelected([...selected].concat(x))}
                />
                <div>
                    {selected
                        .sort((a, b) => {
                            const aName = roles.find(r => r.id === a).name;
                            const bName = roles.find(r => r.id === b).name;
                            return aName > bName ? 1 : -1;
                        })
                        .map(s => (
                            <label
                                key={`role-${s}`}
                                className="label label-primary mr5 pointer"
                                onClick={() => setSelected(selected.filter(x => x !== s))}
                            >
                                <i className="fa fa-trash mr5" />
                                {roles.find(r => r.id === s).name}
                            </label>
                        ))}
                </div>
                {ArrayHelpers.existsAndHasLength(selected) && (
                    <div className="mt20">
                        {loading ? (
                            <Loading />
                        ) : (
                            <div>
                                <hr className="mb10" />
                                <Wizard
                                    inPreview
                                    appraisal={preview}
                                    stage={stage}
                                    setStage={setStage}
                                    inReview={inReview}
                                    setInReview={setInReview}
                                    setAgreedRatingValue={() => null}
                                    profile={{
                                        id: 1,
                                        first_Name: SystemText('Admin/Roles/Preview/ExampleName'),
                                        full_Name: SystemText('Admin/Roles/Preview/ExampleName'),
                                    }}
                                    state={{ inProgress: true }}
                                    updateAppraisal={() => null}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default Preview;
